import { render } from "./Tab3.vue?vue&type=template&id=3791c21d&scoped=true"
import script from "./Tab3.vue?vue&type=script&lang=ts"
export * from "./Tab3.vue?vue&type=script&lang=ts"

import "./Tab3.vue?vue&type=style&index=0&id=3791c21d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3791c21d"

export default script